import TicketTemplateDialog from './TicketTemplateDialog';

export { TicketTemplateDialog };
export default TicketTemplateDialog;
